import type { SilentMentionNotification as SilentMentionNotificationType } from '@/@types/notification'
import ClickableStackAvatarGroup from '@/components/ClickableStackAvatarGroup'
import ScreenNames from '@/components/ScreenNames'
import { formatAsRelativeTime } from '@/utils/day'
import useNotificationClickHandler from '@/utils/hooks/useNotificationClickHandler'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import NotificationContainer from './NotificationContainer'
import NotificationReference from './NotificationReference'
import styles from './SilentMentionNotification.module.css'

export interface SilentMentionNotificationProps extends HTMLAttributes<HTMLDivElement> {
	data: SilentMentionNotificationType
}

export default function SilentMentionNotification({
	data,
	className,
	...props
}: SilentMentionNotificationProps) {
	const {
		actionItem: { users, content },
		referenceItem,
		createdAt,
	} = data
	const { handleClick, isClickable } = useNotificationClickHandler(data)

	return (
		<NotificationContainer
			onClick={handleClick}
			isClickable={isClickable}
			className={clsx(styles.container, className)}
			{...props}
		>
			<ClickableStackAvatarGroup data={users} />

			<div className={styles.content}>
				<header className={styles.header}>
					<div className={styles.headerText}>
						<ScreenNames data={users.slice(0, 1)} className={styles.screenNames} />
						<span className={styles.secondaryText}>悄悄提到了你</span>
					</div>
				</header>

				<main className={styles.main}>{content}</main>
				<footer className={styles.footer}>{formatAsRelativeTime(createdAt)}</footer>
			</div>

			<NotificationReference data={referenceItem} />
		</NotificationContainer>
	)
}
